<template>
  <a-card :bordered="false">
    <div class="s_flex_bian_c">
      <a-button type="primary" v-has:productBatchCreate="()=> {$router.push('/product/libs/batch/create?type=add')}">
        <PlusOutlined />
        添加批次
      </a-button>
      <a-button type="primary" ghost v-has:operationRecord="()=>{showVisible=true}">操作记录</a-button>
    </div>
    <a-form class="m-b-20 m-t-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="" name='keyword'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="batch_name">批次名称</a-select-option>
            <a-select-option value="product_name">商品名称</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list'>
      <template v-slot:action="{ record }">
                <a href="javascript:;"  v-has:productBatchEdit="()=> {$router.push('/product/libs/batch/edit?type=edit&id='+record.id)}" class="m-r-15">编辑</a>
                <a href="javascript:;" v-has:productBatchDel='()=>del(record)'>删除</a>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
      :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"/>
      <!-- 操作记录 -->
      <a-modal  :keyboard="false" title="操作记录" centered v-model:visible="showVisible" :width='1000' :footer="null" destroyOnClose>
         <newTable></newTable>
      </a-modal>
  </a-card>
</template>
<script>
  import { PlusOutlined } from "@ant-design/icons-vue";
  import { onMounted, inject, reactive, toRefs,ref } from "vue";
  import { getRouter } from "@/utils/app";
  import { getPageState } from "@/utils/pageState";
  import { getProductBatch,delProductBatch } from "@/api/product";
  import { iscode } from "@/utils/app";
  import useTableSearch from "@/hooks/useTableSearch";
  import newTable from'./components/table.vue'
  // 初始化默认筛选项数值
  let defSearch = {
    start_time: "",
    end_time: "",
    page: 1,
    limit: 10,
    key_type: "batch_name",
    keyword: "",
  };
  export default {
    components: {PlusOutlined,newTable},
    setup() {

      const state = reactive({
        time: [],
        showVisible:false
      });
      let columns = [
        {
          title: "批次ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "批次名称",
          dataIndex: "batch_name",
          key: "batch_name",
        },
        {
          title: "商品名称",
          dataIndex: "product_name",
          key: "product_name",
        },
        {
          title: "规格",
          dataIndex: "product_sku_name",
          key: "product_sku_name",
          customRender:({record})=>{
            return record.product_sku_name ? record.product_sku_name:'单规格'
          } 
        },
        {
          title: "创建时间",
          dataIndex: "created_at",
          key: "created_at",
        },
        {
          title: "备注",
          dataIndex: "remark",
          key: "remark",
        },
        {
          title: "操作",
          key: "action",
          width:130,
          slots: { customRender: "action" },
        },
      ];
      const $router = inject("$router");
      const $Modal = inject("$Modal");
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
      };
      // 删除
      const del = (e) => {
        $Modal.confirm({
          centered: true,
          content: "是否删除批次？",
          onOk: async () => {
            let res = await delProductBatch({batch_id:e.id}).then((res) => res.data);
            if (iscode(res, true)) {
              tableHoosks.initData(getProductBatch, {...search.value});
            }
          },
        });
      };
      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        tableHoosks.initData(getProductBatch, {...search.value});
      });
      return {
        ...toRefs(state),
        ...tableHoosks,
        columns,
        changTime,
        del
      };
    },
  };
</script>